import { clsx } from 'clsx';
import styles from './ui.module.css';

/**
 * Выбор одного значения в форме: взаимоисключающие варианты одной полосой.
 *
 * Только для формы. Список им не переключают: что показывать — ряд раздела
 * (`TabRow`), чем сузить — `FilterSelect`. Пока здесь жили ещё и состояния
 * имущества, одна и та же по смыслу полоса на соседних экранах выглядела
 * по-разному.
 *
 * Это настоящие <button> в общей рамке, а не div с onClick: иначе их
 * пропускает Tab и не видит скринридер.
 */

export interface SegmentedOption<T extends string> {
  value: T;
  label: string;
}

export function Segmented<T extends string>({
  value,
  options,
  onChange,
  disabled,
}: {
  value: T;
  options: readonly SegmentedOption<T>[];
  onChange: (value: T) => void;
  disabled?: boolean;
}) {
  return (
    <div className={styles.segmented}>
      {options.map((option) => (
        <button
          key={option.value}
          type="button"
          className={clsx(
            styles.segmentedItem,
            option.value === value && styles.segmentedItemActive,
          )}
          aria-pressed={option.value === value}
          disabled={disabled}
          onClick={() => onChange(option.value)}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}
